const Hero = require('../hero/script');

class IntroHero extends Hero {

	constructor(el, params) {

		super(el);
	}

	// basemodule methods

	_domReady(){ super._domReady(); }

	_addListeners(){ super._addListeners(); }
	_removeListeners(){ super._removeListeners(); }

	//

	_show(){
		super._show();
	}

	_hide(){
		super._hide();
	}

	_enable(){ super._enable(); }
	_disable(){ super._disable(); }

	_domUpdate(){ super._domUpdate(); }
	_resize(){

		let videoHeight = window.SETTINGS.coords.winHeight * 1.04;
		let topBleed = window.SETTINGS.coords.winHeight * 0.04 / 2;

		this.$el.find('.bg-video').css({
			top: 0 - topBleed,
			left: Math.round((window.SETTINGS.coords.viewportWidth - videoHeight * (1552/728))/2),
			width: Math.round(videoHeight * (1552/728)),
			height: videoHeight
		});
	}
}

module.exports = IntroHero;
